// Cache the logo as a data URL so it embeds reliably into html2canvas exports
// without any CORS issues. The logo is served locally to avoid CORS problems.

let cachedLogoDataUrl = null;
let inflightPromise = null;

const LOGO_URL = '/assets/monument-logo.jpeg';

export const getLogoDataUrl = async () => {
  if (cachedLogoDataUrl) return cachedLogoDataUrl;
  if (inflightPromise) return inflightPromise;

  inflightPromise = (async () => {
    try {
      const res = await fetch(LOGO_URL);
      const blob = await res.blob();
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      cachedLogoDataUrl = dataUrl;
      return dataUrl;
    } catch (e) {
      // Fall back to plain URL if fetch fails
      return LOGO_URL;
    } finally {
      inflightPromise = null;
    }
  })();

  return inflightPromise;
};

export { LOGO_URL };
